import React, { useState, useEffect, useContext, useRef } from 'react';
import { useCart } from '../Context/CartContext';
import env_constants from '../Constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthContext } from '../Context/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from '../Axiosapi';

const CheckoutForm = ({ subtotal, signupDiscount, shippingCost, gstAmount, planDiscountAmount, shippsub, totalIncludingTax }) => {
    const { cart, clearCart } = useCart();
    const { user, token } = useContext(AuthContext);
    const navigate = useNavigate();
    const [addresses, setAddresses] = useState([]);
    const [isShippingDifferent, setIsShippingDifferent] = useState(false);
    const billingInputRef = useRef(null);
    const shippingInputRef = useRef(null);

    useEffect(() => {
        if (user) {
            fetchAddresses();
        }
    }, [user]);

    useEffect(() => {
        if (user && user.email) {
            setFormData(prev => ({ ...prev, email: user.email }));
        }
    }, [user]);

    useEffect(() => {
        fetchGstAndDeliveryCharges();
        fetchPaypalKeys();
    }, []);

    const fetchAddresses = async () => {
        try {
            const response = await axios.get(`${env_constants.API_BASE_URL}/user-addresses`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            setAddresses(response.data.data.shipping_addresses);
        } catch (error) {
            console.error('Error fetching addresses:', error);
        }
    };

    const fetchGstAndDeliveryCharges = async () => {
        try {
            const response = await axios.get(`${env_constants.API_BASE_URL}/brands`);
            const generalSettings = response.data.general_settings;
        } catch (error) {
            console.error('Error fetching GST and delivery charges:', error);
        }
    };

    const fetchPaypalKeys = async () => {
        try {
            const response = await axios.get(`${env_constants.API_BASE_URL}/encrypted-paypal-keys`);
            const { key } = response.data;

            // Decode the key
            const decodedKey = atob(key);


        } catch (error) {
            console.error('Error fetching or decoding PayPal keys:', error);
        }
    };


    const [formData, setFormData] = useState({
        f_name: '',
        l_name: '',
        email: '',
        phone: '',
        street_address: '',
        city: '',
        state: '',
        post_code: '',
        company: '',
        suburb: 'Suburbia',
        status: 'pending',
        subTotal: 0,
        totalGst: 0,
        total_amount: 0,
        grand_total: 0,
        discountedAmount: 0,
        discountPlan: null,
        auth_discount_per: 0,
        auth_discount: 0,
        channel: 'Web',
        payment_status: 'pending',
        payment_method: '',
        delivery_charges: 0,
        admin_delete: false,
        card_number: '',
        exp_date: '',
        cvc: '',
        comment: '',
        payment_intent_id: '',
        user_id: user ? user.id : 0,
        s_f_name: '',
        s_l_name: '',
        s_email: '',
        s_phone: '',
        s_street_address: '',
        s_city: '',
        s_state: '',
        s_post_code: '',
        s_suburb: 'Suburbia',
        s_company: '',
    });

    useEffect(() => {
        if (window.google) {
            initAutocomplete();
        }
    }, []);


    const [activePaymentMethod, setActivePaymentMethod] = useState(null);
    const [errors, setErrors] = useState({});
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const discountamount = signupDiscount + planDiscountAmount

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };


    const initAutocomplete = (inputRef, isShipping) => {
        if (!inputRef || !window.google) return;

        const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
            types: ["geocode"],
            componentRestrictions: { country: "AU" },
        });

        autocomplete.addListener("place_changed", () => handlePlaceSelect(autocomplete, isShipping));
    };


    useEffect(() => {
        if (window.google) {
            if (billingInputRef.current) {
                initAutocomplete(billingInputRef, false);  // Billing Address
            }
            if (shippingInputRef.current) {
                initAutocomplete(shippingInputRef, true); // Shipping Address
            }
        }
    }, [isShippingDifferent]); // ✅ Added dependency so shipping address initializes properly

    const handlePlaceSelect = (autocomplete, isShipping) => {
        const place = autocomplete.getPlace();
        if (!place || !place.address_components) return;

        let street = "", city = "", state = "", postalCode = "";

        place.address_components.forEach((component) => {
            const componentType = component.types[0];

            switch (componentType) {
                case "street_number":
                    street = component.long_name + " " + street;
                    break;
                case "route":
                    street += component.long_name;
                    break;
                case "locality":
                    city = component.long_name;
                    break;
                case "administrative_area_level_1":
                    state = component.short_name;
                    break;
                case "postal_code":
                    postalCode = component.long_name;
                    break;
                default:
                    break;
            }
        });

        const formattedAddress = place.formatted_address;

        setFormData((prev) => ({
            ...prev,
            ...(isShipping
                ? { s_street_address: formattedAddress, s_city: city, s_state: state, s_post_code: postalCode }
                : { street_address: formattedAddress, city: city, state: state, post_code: postalCode }),
        }));

        // Clear errors for these fields
        setErrors(prevErrors => ({
            ...prevErrors,
            ...(isShipping
                ? { s_street_address: undefined, s_city: undefined, s_state: undefined, s_post_code: undefined }
                : { street_address: undefined, city: undefined, state: undefined, post_code: undefined }),
        }));

        if (isShipping && shippingInputRef.current) {
            shippingInputRef.current.value = formattedAddress;
        } else if (!isShipping && billingInputRef.current) {
            billingInputRef.current.value = formattedAddress;
        }
    };



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let formattedValue = value;

        const alphabeticFields = ['f_name', 'l_name', 'city', 'state', 's_f_name', 's_l_name', 's_city', 's_state'];
        const numericFields = ['phone', 'post_code', 's_phone', 's_post_code'];

        if (name === 'street_address' || name === 's_street_address') {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
            return;
        }

        if (alphabeticFields.includes(name)) {
            const regex = /^[A-Za-z\s]*$/;
            if (!regex.test(value)) {
                setErrors((prevErrors) => ({ ...prevErrors, [name]: 'Only alphabetic characters are allowed' }));
                return;
            } else {
                setErrors((prevErrors) => {
                    const { [name]: removedError, ...restErrors } = prevErrors;
                    return restErrors;
                });
            }
        }

        if (numericFields.includes(name)) {
            const regex = /^\+?[0-9]*$/;
            if (!regex.test(value)) {
                setErrors((prevErrors) => ({ ...prevErrors, [name]: 'Only numeric characters and + are allowed' }));
                return;
            } else {
                setErrors((prevErrors) => {
                    const { [name]: removedError, ...restErrors } = prevErrors;
                    return restErrors;
                });
            }
        }

        // Enhanced email validation
        if (name === 'email' || name === 's_email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (value && !emailRegex.test(value)) {
                setErrors((prevErrors) => ({ ...prevErrors, [name]: 'Invalid email format' }));
            } else {
                setErrors((prevErrors) => {
                    const { [name]: removedError, ...restErrors } = prevErrors;
                    return restErrors;
                });
            }
        }

        setFormData((prevData) => ({
            ...prevData,
            [name]: formattedValue,
        }));
    };


    const handlePaymentMethodClick = (method) => {

        // Validate the form
        const newErrors = validateForm();
        setErrors(newErrors);

        // Check if there are any errors
        if (Object.keys(newErrors).length === 0) {
            // No errors, proceed with payment selection
            setActivePaymentMethod(method);
        } else {
            // Show error message
            toast.error('Please fill in all required fields correctly before proceeding.');
            setActivePaymentMethod(null);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = validateForm();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setActivePaymentMethod(null); // Reset payment method selection
            return;
        }

        if (!cart || cart.length === 0) {
            toast.error('Cart is empty. Please add items to the cart before placing an order.');
            return;
        }

        if (formData.subTotal === '0.00') {
            toast.error('Subtotal cannot be zero. Please add items to the cart.');
            return;
        }

        if (activePaymentMethod !== 'Paypal') {
            await placeOrder();
        }
    };


    const placeOrder = async (transactionId = null) => {
        const cartData = cart.map((item) => {
            const priceMeta = item.product_meta.find((meta) => meta.option === '_price');
            const discountMeta = item.discount_data;
            const price = priceMeta ? parseFloat(priceMeta.value) : 0;
            const discountPrice = discountMeta ? parseFloat(discountMeta.discounted_price) : price;

            return {
                id: item.id,
                quantity: item.quantity,
                qp_subtotal: (discountPrice * item.quantity).toFixed(2),
            };
        });

        const dataToSend = {
            ...formData,
            products: cartData,
            payment_method: activePaymentMethod,
            total_amount: parseFloat(totalIncludingTax.toFixed(2)),
            payment_intent_id: transactionId || formData.payment_intent_id,
            payment_status: activePaymentMethod === 'Paypal' ? 'completed' : 'pending',
            exp_date: formData.exp_date.replace('/', ','),
            auth_discount_per: formData.auth_discount_per,
            auth_discount: formData.discountedAmount,
            totalGst: parseFloat(gstAmount.toFixed(2)),
            subTotal: parseFloat(subtotal.toFixed(2)),
            grand_total: parseFloat(totalIncludingTax.toFixed(2)),
            discountedAmount: parseFloat(discountamount.toFixed(2)),
            auth_discount_per: parseFloat(signupDiscount.toFixed(2)),
            delivery_charges: parseFloat(shippingCost.toFixed(2)),
        };

        try {
            const response = await fetch(`${env_constants.API_BASE_URL}/place-order`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend),
            });

            if (response.ok) {
                const result = await response.json();
                console.log('Order submitted successfully:', result);

                navigate('/thank-you');
                clearCart();
                toast.success(result?.message || 'Order placed successfully!');
            } else {
                console.error('Failed to submit order');
                const errorData = await response.json();
                toast.error(errorData?.message || errorData?.error || 'Order submission failed');
            }
        } catch (error) {
            console.error('Error submitting order:', error);
            toast.error(error?.message || 'Error submitting order. Please try again later.');
        } finally {
            console.log('Order submission complete');
        }
    };

    const validateForm = () => {
        let newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Billing address validation
        if (!formData.f_name) newErrors.f_name = 'First name is required';
        if (!formData.l_name) newErrors.l_name = 'Last name is required';

        if (!formData.email) {
            newErrors.email = 'Email is required';
        } else if (!emailRegex.test(formData.email)) {
            newErrors.email = 'Invalid email format';
        }

        if (!formData.phone) newErrors.phone = 'Phone number is required';
        if (!formData.street_address) newErrors.street_address = 'Street address is required';
        if (!formData.city) newErrors.city = 'City is required';
        if (!formData.state) newErrors.state = 'State is required';
        if (!formData.post_code) newErrors.post_code = 'Post code is required';

        // Shipping address validation (only if different shipping is selected)
        if (isShippingDifferent) {
            if (!formData.s_f_name) newErrors.s_f_name = 'First name is required';
            if (!formData.s_l_name) newErrors.s_l_name = 'Last name is required';

            if (!formData.s_email) {
                newErrors.s_email = 'Email is required';
            } else if (!emailRegex.test(formData.s_email)) {
                newErrors.s_email = 'Invalid email format';
            }

            if (!formData.s_phone) newErrors.s_phone = 'Phone number is required';
            if (!formData.s_street_address) newErrors.s_street_address = 'Street address is required';
            if (!formData.s_city) newErrors.s_city = 'City is required';
            if (!formData.s_state) newErrors.s_state = 'State is required';
            if (!formData.s_post_code) newErrors.s_post_code = 'Post code is required';
        }

        return newErrors;
    };

    useEffect(() => {
        // Skip if no payment method is selected
        if (!activePaymentMethod) return;

        const prepareCartData = () => {
            return cart.map((item) => {
                const priceMeta = item.product_meta.find((meta) => meta.option === '_price');
                const discountMeta = item.discount_data;
                const price = priceMeta ? parseFloat(priceMeta.value) : 0;
                const discountPrice = discountMeta ? parseFloat(discountMeta.discounted_price) : price;

                return {
                    id: item.id,
                    quantity: item.quantity,
                    qp_subtotal: (discountPrice * item.quantity).toFixed(2),
                };
            });
        };

        const dataToSend = {
            ...formData,
            products: prepareCartData(),
            payment_method: activePaymentMethod,
            total_amount: parseFloat(totalIncludingTax.toFixed(2)),
            payment_status: activePaymentMethod === 'Paypal' ? 'completed' : 'pending',
            exp_date: formData.exp_date ? formData.exp_date.replace('/', ',') : '',
            auth_discount_per: parseFloat(signupDiscount.toFixed(2)),
            auth_discount: parseFloat((signupDiscount || 0).toFixed(2)),
            totalGst: parseFloat(gstAmount.toFixed(2)),
            subTotal: parseFloat(subtotal.toFixed(2)),
            grand_total: parseFloat(totalIncludingTax.toFixed(2)),
            discountedAmount: parseFloat(discountamount.toFixed(2)),
            delivery_charges: parseFloat(shippingCost.toFixed(2)),
        };

        // Store dataToSend in session storage
        sessionStorage.setItem('paypalCheckoutData', JSON.stringify(dataToSend));
        sessionStorage.setItem('stripeCheckoutData', JSON.stringify(dataToSend));

        // Clear session storage after 5 minutes
        const timeoutIdPaypal = setTimeout(() => {
            sessionStorage.removeItem('paypalCheckoutData');
        }, 300000);

        const timeoutIdStripe = setTimeout(() => {
            sessionStorage.removeItem('stripeCheckoutData');
        }, 300000);

        // Navigate based on payment method
        if (activePaymentMethod === 'Paypal') {
            navigate('/checkout-paypal-payment');
        } else if (activePaymentMethod === 'Credit Card / Debit Card') {
            navigate('/checkout-stripe-payment');
        }

        // Clean up timeouts
        return () => {
            clearTimeout(timeoutIdPaypal);
            clearTimeout(timeoutIdStripe);
        };
    }, [activePaymentMethod]);

    const handleAddressSelection = (address) => {
        setFormData(prevState => ({
            ...prevState,
            f_name: address.f_name,
            l_name: address.l_name,
            email: address.email,
            phone: address.phone,
            street_address: address.street_address,
            city: address.city,
            state: address.state,
            post_code: address.post_code
        }));
        setIsSidebarOpen(false);
    };

    const handleShippingCheckboxChange = (e) => {
        setIsShippingDifferent(e.target.checked);
    };


    return (
        <div>
            <div className={`checkout-addresses-sidebar ${isSidebarOpen ? 'open' : ''}`}>
                {addresses.map((address, index) => (
                    <div key={index} className='address-item'>
                        <div className='border border-danger rounded p-4'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <h4 className='m-0'>{`Address ${index + 1}`}</h4>
                                <input
                                    type='radio'
                                    name='selectedAddress'
                                    onChange={() => handleAddressSelection(address)}
                                />
                            </div>
                            <table className='mt-3'>
                                <tbody>
                                    <tr>
                                        <td className='pb-2'>F-Name</td>
                                        <td className='pb-2'>:</td>
                                        <td className='pb-2'>{address.f_name}</td>
                                    </tr>
                                    <tr>
                                        <td className='pb-2'>L-Name</td>
                                        <td className='pb-2'>:</td>
                                        <td className='pb-2'>{address.l_name}</td>
                                    </tr>
                                    <tr>
                                        <td className='pb-2'>Email</td>
                                        <td className='pb-2'>:</td>
                                        <td className='pb-2' style={{ wordBreak: 'break-all' }}>{address.email}</td>
                                    </tr>
                                    <tr>
                                        <td className='pb-2'>Phone</td>
                                        <td className='pb-2'>:</td>
                                        <td className='pb-2'>{address.phone}</td>
                                    </tr>
                                    <tr>
                                        <td className='pb-2'>Address</td>
                                        <td className='pb-2'>:</td>
                                        <td className='pb-2'>{address.street_address}</td>
                                    </tr>
                                    <tr>
                                        <td className='pb-2'>City</td>
                                        <td className='pb-2'>:</td>
                                        <td className='pb-2'>{address.city}</td>
                                    </tr>
                                    <tr>
                                        <td className='pb-2'>State</td>
                                        <td className='pb-2'>:</td>
                                        <td className='pb-2'>{address.state}</td>
                                    </tr>
                                    <tr>
                                        <td className='pb-2 pe-2'>Post Code</td>
                                        <td className='pb-2'>:</td>
                                        <td className='pb-2'>{address.post_code}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
            </div>

            <form onSubmit={handleSubmit}>
                <div className='checkout-personal-information'>
                    <div className='d-flex justify-content-between align-items-center'>
                        <h2 className='personal-heading'>Billing Details</h2>
                        {addresses.length > 0 && (
                            <button type='button' className="sidebar-toggle-btn" onClick={toggleSidebar}>
                                Show Addresses
                            </button>
                        )}
                    </div>

                    <div className='row mt-4'>
                        <div className='col-md-6 mb-3'>
                            <input
                                type='text'
                                name='f_name'
                                placeholder='First Name *'
                                className={`personal-information-fields ${errors.f_name ? 'border border-danger' : ''}`}
                                value={formData.f_name}
                                onChange={handleInputChange}
                                autoComplete='off'
                            />
                            {errors.f_name && <p className='error-text'>{errors.f_name}</p>}
                        </div>

                        <div className='col-md-6 mb-3'>
                            <input
                                type='text'
                                name='l_name'
                                placeholder='Last Name *'
                                className={`personal-information-fields ${errors.l_name ? 'border border-danger' : ''}`}
                                value={formData.l_name}
                                onChange={handleInputChange}
                                autoComplete='off'
                            />
                            {errors.l_name && <p className='error-text'>{errors.l_name}</p>}
                        </div>

                        <div className='col-md-6 mb-3'>
                            <input
                                type='email'
                                name='email'
                                placeholder='Email *'
                                className={`personal-information-fields ${errors.email ? 'border border-danger' : ''}`}
                                value={formData.email || ''}
                                onChange={handleInputChange}
                                autoComplete='off'
                            />
                            {errors.email && <p className='error-text'>{errors.email}</p>}
                        </div>

                        <div className='col-md-6 mb-3'>
                            <input
                                type='tel'
                                name='phone'
                                placeholder='Phone *'
                                className={`personal-information-fields ${errors.phone ? 'border border-danger' : ''}`}
                                value={formData.phone}
                                onChange={handleInputChange}
                                autoComplete='off'
                            />
                            {errors.phone && <p className='error-text'>{errors.phone}</p>}
                        </div>

                        <div className='col-md-12 mb-3'>
                            <input
                                type="text"
                                name="street_address"
                                placeholder="Street Address *"
                                className={`personal-information-fields ${errors.street_address ? 'border border-danger' : ''}`}
                                value={formData.street_address}
                                onChange={handleInputChange}
                                ref={billingInputRef}
                                autoComplete='off'
                            />
                            {errors.street_address && <p className='error-text'>{errors.street_address}</p>}
                        </div>

                        <div className='col-md-6 mb-3'>
                            <input
                                type="text"
                                name="city"
                                placeholder="City *"
                                className={`personal-information-fields ${errors.city ? 'border border-danger' : ''}`}
                                value={formData.city}
                                onChange={handleInputChange}
                                autoComplete='off'
                            />
                            {errors.city && <p className='error-text'>{errors.city}</p>}
                        </div>

                        <div className='col-md-6 mb-3'>
                            <input
                                type="text"
                                name="state"
                                placeholder="State *"
                                className={`personal-information-fields ${errors.state ? 'border border-danger' : ''}`}
                                value={formData.state}
                                onChange={handleInputChange}
                                autoComplete='off'
                            />
                            {errors.state && <p className='error-text'>{errors.state}</p>}
                        </div>

                        <div className='col-md-6 mb-3'>
                            <input
                                type="number"
                                name="post_code"
                                placeholder="Post Code *"
                                className={`personal-information-fields ${errors.post_code ? 'border border-danger' : ''}`}
                                value={formData.post_code}
                                onChange={handleInputChange}
                                autoComplete='off'
                            />
                            {errors.post_code && <p className='error-text'>{errors.post_code}</p>}
                        </div>

                        <div className='col-md-6 mb-3'>
                            <input
                                type='text'
                                name='company'
                                placeholder='Company (Optional)'
                                className='personal-information-fields'
                                value={formData.company}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className='col-md-12 mb-3'>
                            <label className='d-flex align-items-center'>
                                <input
                                    type='checkbox'
                                    className='me-2'
                                    onChange={handleShippingCheckboxChange}
                                />
                                Ship to a different address
                            </label>
                        </div>
                        {isShippingDifferent && (
                            <div className='col-md-12'>
                                <h2 className='personal-heading mb-4'>Shipping Details</h2>
                                <div className='row'>
                                    <div className='col-md-6 mb-3'>
                                        <input
                                            type='text'
                                            name='s_f_name'
                                            placeholder='First Name *'
                                            className={`personal-information-fields ${errors.s_f_name ? 'border border-danger' : ''}`}
                                            value={formData.s_f_name}
                                            onChange={handleInputChange}
                                            autoComplete='off'
                                        />
                                        {errors.s_f_name && <p className='error-text'>{errors.s_f_name}</p>}
                                    </div>

                                    <div className='col-md-6 mb-3'>
                                        <input
                                            type='text'
                                            name='s_l_name'
                                            placeholder='Last Name *'
                                            className={`personal-information-fields ${errors.s_l_name ? 'border border-danger' : ''}`}
                                            value={formData.s_l_name}
                                            onChange={handleInputChange}
                                            autoComplete='off'
                                        />
                                        {errors.s_l_name && <p className='error-text'>{errors.s_l_name}</p>}
                                    </div>

                                    <div className='col-md-6 mb-3'>
                                        <input
                                            type='email'
                                            name='s_email'
                                            placeholder='Email *'
                                            className={`personal-information-fields ${errors.s_email ? 'border border-danger' : ''}`}
                                            value={formData.s_email}
                                            onChange={handleInputChange}
                                            autoComplete='off'
                                        />
                                        {errors.s_email && <p className='error-text'>{errors.s_email}</p>}
                                    </div>

                                    <div className='col-md-6 mb-3'>
                                        <input
                                            type='tel'
                                            name='s_phone'
                                            placeholder='Phone *'
                                            className={`personal-information-fields ${errors.s_phone ? 'border border-danger' : ''}`}
                                            value={formData.s_phone}
                                            onChange={handleInputChange}
                                            autoComplete='off'
                                        />
                                        {errors.s_phone && <p className='error-text'>{errors.s_phone}</p>}
                                    </div>

                                    <div className='col-md-12 mb-3'>
                                        <input
                                            type="text"
                                            name="s_street_address"
                                            placeholder="Shipping Street Address *"
                                            className={`personal-information-fields ${errors.s_street_address ? 'border border-danger' : ''}`}
                                            value={formData.s_street_address}
                                            onChange={handleInputChange}
                                            ref={shippingInputRef}
                                            autoComplete='off'
                                        />
                                        {errors.s_street_address && <p className='error-text'>{errors.s_street_address}</p>}
                                    </div>

                                    <div className='col-md-6 mb-3'>
                                        <input
                                            type='text'
                                            name='s_city'
                                            placeholder='City *'
                                            className={`personal-information-fields ${errors.s_city ? 'border border-danger' : ''}`}
                                            value={formData.s_city}
                                            onChange={handleInputChange}
                                            autoComplete='off'
                                        />
                                        {errors.s_city && <p className='error-text'>{errors.s_city}</p>}
                                    </div>

                                    <div className='col-md-6 mb-3'>
                                        <input
                                            type='text'
                                            name='s_state'
                                            placeholder='State *'
                                            className={`personal-information-fields ${errors.s_state ? 'border border-danger' : ''}`}
                                            value={formData.s_state}
                                            onChange={handleInputChange}
                                            autoComplete='off'
                                        />
                                        {errors.s_state && <p className='error-text'>{errors.s_state}</p>}
                                    </div>

                                    <div className='col-md-6 mb-3'>
                                        <input
                                            type='number'
                                            name='s_post_code'
                                            placeholder='Post Code *'
                                            className={`personal-information-fields ${errors.s_post_code ? 'border border-danger' : ''}`}
                                            value={formData.s_post_code}
                                            onChange={handleInputChange}
                                            autoComplete='off'
                                        />
                                        {errors.s_post_code && <p className='error-text'>{errors.s_post_code}</p>}
                                    </div>

                                    <div className='col-md-6 mb-3'>
                                        <input
                                            type='text'
                                            name='s_company'
                                            placeholder='Company (Optional)'
                                            className='personal-information-fields'
                                            value={formData.s_company}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className='checkout-payment-box'>
                    <h2 className='personal-heading d-flex align-items-center gap-3'>Payment Method</h2>
                    <div className='d-flex flex-wrap gap-3 mt-4'>
                        {['Credit Card / Debit Card', 'Paypal'].map((method, index) => (
                            <button
                                type="button"
                                className={`payment-buttons ${activePaymentMethod === method ? 'active' : ''}`}
                                onClick={() => handlePaymentMethodClick(method)}
                                key={index}
                            >
                                {method}
                            </button>
                        ))}
                    </div>

                    {activePaymentMethod === 'Credit Card / Debit Card' && (
                        <div className='mt-4'>

                        </div>
                    )}

                    {activePaymentMethod === 'Paypal' && (
                        <div className='mt-4'>

                        </div>
                    )}
                </div>

                <div className='checkout-comment'>
                    <h2 className='personal-heading'>Comment (Optional)</h2>
                    <textarea
                        name='comment'
                        placeholder='Write your comment (max 250 characters)'
                        value={formData.comment}
                        onChange={handleInputChange}
                        maxlength="250"
                    ></textarea>
                </div>
            </form>
        </div>
    );
};

export default CheckoutForm;